var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTcLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TandC.f4088c36",
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 71,
    viewBox: "0 0 85 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M54.265,57.853c12.922,0,21.719-6.79,23.86-18.353h-8.68C67.693,46.251,62.127,50.248,54.3,50.248c-10.315,0-16.854-8.265-16.854-21.341,0-12.96,6.617-21.3,16.815-21.3,7.629,0,13.623,4.695,15.18,11.873h8.641C76.607,7.8,66.993,0,54.265,0,38.579,0,28.537,11.175,28.537,28.907,28.537,46.756,38.5,57.853,54.265,57.853Z",
    transform: "translate(5.039)",
    fill: "#356dff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M27.422,55.787V7.461H59.314V0h-58V7.461H18.642V55.787Z",
    transform: "translate(0.233)",
    fill: "#356dff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 85,
    height: 7,
    transform: "translate(0 64)",
    fill: "#356dff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcLogo);
export default __webpack_public_path__ + "static/media/tcLogo.a8c82c3924bc3fc624c4324ba753cd25.svg";
export { ForwardRef as ReactComponent };